<div class="audio_view">
  <div class="audio_content">
    <div class="">
      @if (!audioInput.user_icon) {
      <empty-uname
        [userName]="audioInput.first_name"
        [detailHeadProfile]="true"
      >
      </empty-uname>
      } @if (audioInput.user_icon) {
      <img [src]="profileUrl + audioInput.user_icon" class="is-pulled-left" />
      }
    </div>
    <h2>{{ audioInput.first_name + " " + audioInput.last_name }}</h2>
    @if (audioRinging) {
    <p class="is-small">Ringing...</p>
    } @if (!audioRinging) {
    <p class="is-small">{{ countDown }}</p>
    }
    <a class="audio_btn" (click)="audioCallEnd()"
      ><i class="fa fa-phone rotate-img"></i
    ></a>

    @if (!audioRinging) {
    <div class="conference_icon">
      <a class="option_btn"><i class="fa fa-video-camera"></i></a>
      <a class="option_btn"><i class="fa fa-microphone"></i></a>
      <a class="option_btn" (click)="addMoreMembers()"
        ><i class="fa fa-user-plus"></i
      ></a>
      <a class="option_btn"><i class="fa fa-commenting"></i></a>
    </div>
    }
  </div>
</div>

<!--
<div class="audio_view">
  <div class="audio_content">
    <div class="" *ngIf="!audioPanelView">
      <div>
        <empty-uname [userName]="audioInput.first_name" [detailHeadProfile]="true"
          *ngIf="!audioInput.user_icon">
        </empty-uname>
        <img [src]="profileUrl+audioInput.user_icon" *ngIf="audioInput.user_icon" class="is-pulled-left">
      </div>
      <h2>{{audioInput.first_name + ' ' + audioInput.last_name}}</h2>
      <p class="is-small" *ngIf="audioRinging">Ringing...</p>
      <a class="audio_btn" (click)="audioCallEnd()"><i class="fa fa-phone rotate-img"></i></a>
    </div>
    <div class="" *ngIf="audioPanelView">
      <h1 style="font-size:30px">{{audioInput.first_name + ' ' + audioInput.last_name}}</h1>
      <video #remoteVideo width="320" height="240" autoplay muted="muted"></video>
    </div>
    <div class="audio_receiver" *ngIf="audioPanelView">
      <div class="audio_rec_view">
        <video #localVideo width="160" autoplay height="120" id='local' muted="muted"></video>
      </div>
    </div>

    <div class="conference_icon" *ngIf="audioPanelView">
      <a class="option_btn" (click)="screenShare()" *ngIf=!screenShareIcon><i class="fa fa-desktop"></i></a>
      <a class="option_btn" (click)="screenShareStop()" *ngIf=screenShareIcon><i
      [ngStyle]="screenShareIcon && { 'color':'red'}" class="fa fa-desktop"></i></a>

      <a class="option_btn" *ngIf="!videoIcon"  (click)="video()"><i [ngStyle]="!videoIcon && { 'color':'red'}"
      class="fa fa-video-camera"></i></a>

      <a class="option_btn"  *ngIf="videoIcon" (click)="videoStop()()"><i
        class = "fa fa-video-camera">
      </i>
    </a>

    <a class="option_btn" (click)="muteMicrophone()"><i
      [ngClass]="mute ? 'fa fa-microphone' : ' fa fa-microphone-slash'"
    [ngStyle]="!mute && { 'color':'red'}"></i></a>
    <a class="option_btn" (click)="audioCallEnd()"><i class="fa fa-phone rotate-img"></i></a>
  </div>
</div>
</div> -->
